module.exports = __webpack_public_path__ + "img/onlineStudy.aaf93e81.jpg";